import { Component, inject } from '@angular/core';
import { LoadingService } from '../../core/services/loading.service';

/**
 * Barra fina e não bloqueante no topo da tela, exibida pelo LoadingService
 * quando há requisição demorada em andamento. Substitui o antigo reuso da
 * splash de boot (#loaderBox) como loader de requisição.
 */
@Component({
    selector: 'app-top-loader',
    standalone: true,
    template: `
        @if (loading.visible()) {
            <div class="top-loader" role="progressbar" aria-label="Carregando">
                <div class="top-loader-fill"></div>
            </div>
        }
    `,
    styles: [`
        .top-loader {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            height: 3px;
            /* acima dos modais Swal/Material, abaixo da splash de boot (999999) */
            z-index: 100000;
            pointer-events: none;
            overflow: hidden;
        }
        .top-loader-fill {
            width: 40%;
            height: 100%;
            border-radius: 2px;
            background: var(--app-accent-color);
            animation: topLoaderSlide 1.1s ease-in-out infinite;
        }
        @keyframes topLoaderSlide {
            0%   { transform: translateX(-110%); }
            100% { transform: translateX(260%); }
        }
        @media (prefers-reduced-motion: reduce) {
            .top-loader-fill {
                animation: none;
                width: 100%;
                opacity: 0.6;
            }
        }
    `]
})
export class TopLoaderComponent {
    readonly loading = inject(LoadingService);
}
